"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToAction = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../..");
var useTheme_1 = require("../../hooks/useTheme");
var CallToActionContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* .lagom-call-to-action */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  p {\n    font-weight: normal;\n    font-size: 20px;\n    text-align: center;\n    margin: 0 auto 4rem auto;\n    padding: 0 2rem 0 2rem;\n\n    ", " {\n      font-size: 16px;\n      margin: 0 auto 2rem auto;\n      padding: 0 1rem 0 1rem;\n    }\n  }\n"], ["\n  /* .lagom-call-to-action */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  p {\n    font-weight: normal;\n    font-size: 20px;\n    text-align: center;\n    margin: 0 auto 4rem auto;\n    padding: 0 2rem 0 2rem;\n\n    ", " {\n      font-size: 16px;\n      margin: 0 auto 2rem auto;\n      padding: 0 1rem 0 1rem;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.large;
});
var CallToAction = function (_a) {
    var className = _a.className, header = _a.header, text = _a.text, actionLink = _a.actionLink, actionText = _a.actionText, LinkComponent = _a.LinkComponent, restProps = __rest(_a, ["className", "header", "text", "actionLink", "actionText", "LinkComponent"]);
    var mergedTheme = (0, useTheme_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(CallToActionContainer, __assign({ theme: mergedTheme, className: (0, clsx_1.default)("lagom-call-to-action", className) }, restProps, { children: [!!header && ((0, jsx_runtime_1.jsx)(__1.SectionHeader, { className: "lagom-call-to-action__header", children: header })), !!text && (0, jsx_runtime_1.jsx)("p", { className: "lagom-call-to-action__text", children: text }), !!actionLink && !!actionText && ((0, jsx_runtime_1.jsx)(__1.LinkButton, { className: "lagom-call-to-action__link", to: actionLink, Component: LinkComponent, style: { margin: "0 auto", backgroundColor: "transparent" }, children: actionText }))] })));
};
exports.CallToAction = CallToAction;
var templateObject_1;
//# sourceMappingURL=CallToAction.js.map